module.exports = __webpack_public_path__ + "img/keyData-Checked.55a32fe7.svg";